import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { Flex } from 'ui/bend'

import EventCard from './EventCard'

const List = styled(Flex)(
  css({
    flexDirection: 'column',
    gap: ['24px', null, '28px'],
    width: '100%',
    maxWidth: '1040px',
    mx: 'auto'
  })
)

const EventsGrid = ({ events, onRegistrationChange }) => (
  <List>
    {events.map((event) => (
      <EventCard
        key={event.id}
        event={event}
        onRegistrationChange={onRegistrationChange}
      />
    ))}
  </List>
)

EventsGrid.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRegistrationChange: PropTypes.func
}

export default EventsGrid
